'use client'

import { AppErrorFallback } from '@/shared/ui'

/** 앱 웹뷰는 401이면 재로그인하므로 재로그인이 안 된 경우에만 보인다. 다시 시도는 문서를 새로 받아 401을 다시 낸다. */
export default function Unauthorized() {
  return (
    <AppErrorFallback
      reset={() => window.location.reload()}
      componentName='Unauthorized'
    />
  )
}
